import { render } from "./TableList.vue?vue&type=template&id=9428aea8&scoped=true&ts=true"
import script from "./TableList.vue?vue&type=script&lang=ts"
export * from "./TableList.vue?vue&type=script&lang=ts"

import "./TableList.vue?vue&type=style&index=0&id=9428aea8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9428aea8"]])

export default __exports__